import _extends from "@babel/runtime/helpers/esm/extends";
import { SuperDashboardCard } from "../../SuperDashboard";
import { Typography } from 'antd';
import _ from 'lodash';
import React from 'react';
import { useStyles } from "./_.style";
export var ResourceStateStatistics = /*#__PURE__*/React.forwardRef(function (properties, ref) {
  var colors = ['#1a9850', '#66bd63', '#a6d96a', '#d9ef8b', '#ffffbf', '#fee08b', '#fdae61', '#f46d43', '#d73027'];
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  return /*#__PURE__*/React.createElement(SuperDashboardCard, _extends({
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: '#F5F7FA',
      padding: '12px 20px',
      // width: '64px',
      // height: '64px',
      borderRadius: '50%',
      color: '#707275',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '36px',
      color: '#181A1D',
      cursor: 'pointer'
    }
  }, _.sumBy(properties.datum, 'value')))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 3
    }
  }, properties.datum.map(function (data, dataIndex) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.record
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        backgroundColor: colors[dataIndex % colors.length],
        display: 'inline-block',
        width: '8px',
        height: '8px',
        borderRadius: '50%'
      }
    }), /*#__PURE__*/React.createElement("span", null, data.key)), /*#__PURE__*/React.createElement(Typography.Text, {
      ellipsis: true
    }, data.value));
  }))), properties.children);
});
ResourceStateStatistics.isProCard = true;